import script from "./VTaskPanelLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTaskPanelLayer.vue?vue&type=script&setup=true&lang=ts"

import "./VTaskPanelLayer.vue?vue&type=style&index=0&id=023d193c&lang=scss"

const __exports__ = script;

export default __exports__